define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Provincial_2",
        THEMESETS_IDS: ["Provincial_2"],
        TOP_PANEL: {
            PRINT_OPTIONS: {"landscape": true, "scale": 0.5},
            DEFAULTS: {
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 25, "top": 15, "right": 0, "bottom": 10},
                X_DATA_NAMES: [
                    "2008-2009", "2009-2010", "2010-2011", "2011-2012", "2012-2013", "2013-2014", "2014-2015", "2015-2016", "2016-2017",
                    "2017-2018", "2018-2019", "2019-2020", "2020-2021", "2021-2022", "2022-2023", "2023-2024"],
                X_AXIS_TICK_ROTATE: -90,
                // X_AXIS_LABEL: {"text": "Années scolaires", "position": "outer-right"},
                Y_AXIS_LABEL: "%",
                Y_AXIS_PADDING: 0,
                Y_GRID: true,
                TOOLTIP_TITLE_FN: function(x, graph) { return "Année scolaire " + graph.categories()[x]; },
                // LEGEND_POSITION : "right",
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%"; },
            },
            SLIDES: [
                {
                    TITLE: "Taux annuel de sorties sans diplôme ni qualification selon certaines caractéristiques, ensemble du Québec, 2008-2009 à 2023-2024",
                    GRAPHS: [
                        {
                            TITLE: "Élèves avec un plan d\'intervention actif (élèves HDAA)",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 60,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_COLORS: {"Élèves HDAA": "#095797", "Élèves non HDAA": "#95BFDD"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["3"],
                                    FEATURES_DATA_IDS: ["Élèves HDAA"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["4"],
                                    FEATURES_DATA_IDS: ["Élèves non HDAA"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                            ]
                        },
                        {
                            TITLE: "Élèves en retard dans la classe",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 60,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_COLORS: {"Élèves avec retard": "#78740C", "Élèves sans retard": "#D0DC03"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["5"],
                                    FEATURES_DATA_IDS: ["Élèves avec retard"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["6"],
                                    FEATURES_DATA_IDS: ["Élèves sans retard"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                            ]
                        },
                        {
                            TITLE: "Élèves issus de l'immigration",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 60,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_COLORS: {"Immigrants (première génération)": "#248B65", "Élèves non immigrants": "#68CEBA"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["7"],
                                    FEATURES_DATA_IDS: ["Immigrants (première génération)"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["8"],
                                    FEATURES_DATA_IDS: ["Élèves non immigrants"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                            ]
                        },
                        {
                            TITLE: "Élèves fréquentant une école publique de rang décile IMSE 8, 9 ou 10",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 60,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_COLORS: {"Autres écoles": "#F39C8D", "Écoles publiques IMSE 8 à 10": "#8D5150"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["9"],
                                    FEATURES_DATA_IDS: ["Écoles publiques IMSE 8 à 10"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_CATEGORIES",
                                    FEATURES_IDS: ["10"],
                                    FEATURES_DATA_IDS: ["Autres écoles"],
                                    DATATABLE_ID: "t_Provincial_cat",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_2008_2009", "c_TX_2009_2010", "c_TX_2010_2011", "c_TX_2011_2012", "c_TX_2012_2013", "c_TX_2013_2014", "c_TX_2014_2015",
                                        "c_TX_2015_2016", "c_TX_2016_2017", "c_TX_2017_2018", "c_TX_2018_2019", "c_TX_2019_2020", "c_TX_2020_2021", "c_TX_2021_2022",
                                        "c_TX_2022_2023","c_TX_2023_2024",
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    };
});
